var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGreenTick = function SvgGreenTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#50B844",
    strokeWidth: 3,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M7.96533203 14L12.4339622 18.2328588 19.6728516 10.1645508"
  }))));
};
export default SvgGreenTick;